import { render, staticRenderFns } from "./AdminSystem.vue?vue&type=template&id=6bbefb15&scoped=true&"
import script from "./AdminSystem.vue?vue&type=script&lang=js&"
export * from "./AdminSystem.vue?vue&type=script&lang=js&"
import style0 from "./AdminSystem.vue?vue&type=style&index=0&id=6bbefb15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbefb15",
  null
  
)

export default component.exports